import { useTranslation } from 'react-i18next'

export type Language = 'en' | 'id'

export function useLanguage() {
  const { i18n } = useTranslation()
  const current = i18n.language as Language

  function setLanguage(lang: Language) {
    i18n.changeLanguage(lang)
  }

  function toggle() {
    setLanguage(current === 'id' ? 'en' : 'id')
  }

  return { current, setLanguage, toggle, isIndonesian: current === 'id' }
}
